import * as React from "react";
import PublicLayout from "../Layouts/Public";
import TitleAndInfo from "../TitleAndInfo";
import languages from "../../language/languages";
import { LockOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button } from "antd";
import {Field, reduxForm} from "redux-form";
import {CreatePasswordField} from "../../helpers/InputCreator";
import {required, requireden} from "../../helpers/validations";
import {connect} from "react-redux";
import {push} from "connected-react-router";
import changePassword from "../../actions/changePassword";
import {SHOW_MSG} from "../../types";

class ChangePassword extends React.Component
{
    getPasswordForm=()=>
    {
      return (
          <Form onSubmit={this.props.handleSubmit(this.changePassword)}>
              <Field name="password"
                     prefix={<LockOutlined className={'icon-font'} />}
                     component={CreatePasswordField}
                     size={'large'}
                     className={'mb-10'}
                     visibilityToggle={'false'}
                     placeholder={languages[this.props.language].currentPass}
                     validate={this.props.language === 'es' ? [required] : [requireden]}
                     hasFeedback/>
              <Field name="newPassword"
                     prefix={<LockOutlined className={'icon-font'} />}
                     component={CreatePasswordField}
                     size={'large'}
                     className={'mb-10'}
                     visibilityToggle={'false'}
                     placeholder={languages[this.props.language].newPass}
                     validate={this.props.language === 'es' ? [required] : [requireden]}
                     hasFeedback/>
              <Field name="confirmNewPassword"
                     prefix={<LockOutlined className={'icon-font'} />}
                     component={CreatePasswordField}
                     size={'large'}
                     className={'mb-10'}
                     visibilityToggle={'false'}
                     placeholder={languages[this.props.language].confirmNewPass}
                     validate={this.props.language === 'es' ? [required] : [requireden]}
                     hasFeedback/>
              <Form.Item className={'text-center mb-10'}>
                  <Button  type="primary" htmlType="submit" className={'light-blue rounded'}>
                      {languages[this.props.language].changePass}
                  </Button>
              </Form.Item>
              {this.props.logged?'':<Form.Item className={'text-center'}>
                  <Button onClick={()=>{this.props.push('/')}} type="primary" className={'light-blue rounded'}>
                      {languages[this.props.language].goBack}
                  </Button>
              </Form.Item>}

          </Form>
      );
    };
    changePassword = (form) =>
    {
        form.userName=this.props.userName;
        if(form.newPassword !== form.confirmNewPassword)
            this.props.dispatch({type: SHOW_MSG, payload: {message: languages[this.props.language].dontMatch,type:'error'}});
        else
            this.props.changePassword(form);
    };

    render() {
        if(this.props.logged)
        {
            return <div className="card-container h-100 p-20 tabs-container"><h2>{languages[this.props.language].changePassLabel}</h2>
                {/*<TitleAndInfo info={languages[this.props.language].changePassmsg}/>*/}
                {this.getPasswordForm()}
            </div>;
        }
        return <PublicLayout isRA={this.props.isRA} title={'logo'}>
            <TitleAndInfo info={languages[this.props.language].changePassmsg}/>
            {this.getPasswordForm()}
        </PublicLayout>;
    }
}

const mapStateToProps = state => {
    return {
        language: state.auth.language,
        isRA:state.auth.isRA,
        userName: state.auth.userName,
        logged: state.auth.logged
    };
};

export default connect(mapStateToProps, {push,changePassword})((reduxForm({form: 'changepass_form'})(ChangePassword)));
